import { call, put, takeLatest } from "redux-saga/effects";
import { setIsLoading } from "../../Containers/App/action";
import { accountConfirm } from "../../Domain/api";
import { SET_ACCOUNT_CONFIRMATION } from "./constants";

export function* doSetConfirmation({code, cbSuccess, cbFailed}) {
    try {
        yield put(setIsLoading(true));
        yield call(accountConfirm, {code});
        yield put(setIsLoading(false));
        cbSuccess && cbSuccess();
    } catch (error) {
        yield put(setIsLoading(false));
        cbFailed && cbFailed();
    }
} 

export default function* confirmationSaga() {
    yield takeLatest(SET_ACCOUNT_CONFIRMATION, doSetConfirmation);
}